import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { ProductScreenState } from "./ProductScreenState";

type ProductParamList = {
  ProductMain:
    | {
        ean: string;
        type: "ean";
        state: ProductScreenState;
      }
    | {
        id: string;
        type: "id";
        state: ProductScreenState;
      };
};

type ProductNavigationProp<T extends keyof ProductParamList> =
  CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"Product">,
    NativeStackNavigationProp<ProductParamList, T>
  >;

type ProductStackRouteProp<T extends keyof ProductParamList> = RouteProp<
  ProductParamList,
  T
>;

export type ProductStackScreenProps<T extends keyof ProductParamList> = {
  navigation: ProductNavigationProp<T>;
  route: ProductStackRouteProp<T>;
};
export const ProductStack = createNativeStackNavigator<ProductParamList>();
